// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SETTINGS = {
    DIALOG: 'settings-dialog',
};